module.exports = false;



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/mea/node_modules/@babel/polyfill/node_modules/core-js/modules/_library.js
// module id = 116
// module chunks = 0